<template>
  <el-dialog
    title=""
    :append-to-body="true"
    width="783px"
    top="100px"
    :visible="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="content">
      <iframe :src="componentName" frameborder="0" style="height: 500px; width: 100%;"></iframe>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button type="primary" @click="close">{{ $t('btn.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import LegalAgreementcn from './Legalcn'
import LegalAgreementen from './Legalen'
import LegalAgreementjp from './Legaljp'
import Privacycn from './Prcn'
import Privacyen from './Pren'
import Privacyjp from './Prjp'
export default {
  name: 'agreement',
  components: { LegalAgreementcn, LegalAgreementen, LegalAgreementjp, Privacycn, Privacyen, Privacyjp },
  props: {
    lang: {
      type: String,
      default: 'cn' // en
    },
    type: {
      type: String,
      default: 'legalAgreement' // privacy
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentName() {
      let baseUrl
      let nodeEnv = process.env.NODE_ENV
      if (nodeEnv === 'prd') {
        baseUrl = 'https://dlite3.basf.com/staticPage'
      } else if (nodeEnv === 'test-pro') {
        baseUrl = 'https://dlite3-test.basf.com/staticPage'
      } else {
        baseUrl = 'https://dlite8.bevol.com/staticPage'
      }
      if (this.type === 'legalAgreement') {
        // return 'LegalAgreement' + this.lang
        return `${baseUrl}/userAgreement_${this.lang}.html`
      } else {
        return `${baseUrl}/privacyPolicy_${this.lang}.html`
      }
    }
  },
  methods: {
    close() {
      this.$emit('visible-change', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
>>>.el-dialog__header {
  padding: 0
}
</style>



// WEBPACK FOOTER //
// src/components/base/agreement/Index.vue